export const queryKeys = {
  clients: {
    all: (firmId: string | null) => ['clients', firmId] as const,
    list: (firmId: string | null, filters?: Record<string, unknown>) => ['clients', firmId, 'list', filters] as const,
    detail: (id: string | null) => ['clients', 'detail', id] as const,
  },
  engagements: {
    all: (firmId: string | null) => ['engagements', firmId] as const,
    list: (firmId: string | null, filters?: Record<string, unknown>) => ['engagements', firmId, 'list', filters] as const,
    detail: (id: string | null) => ['engagements', 'detail', id] as const,
  },
  tasks: {
    all: (userId: string | null) => ['tasks', userId] as const,
    list: (userId: string | null, filters?: Record<string, unknown>) => ['tasks', userId, 'list', filters] as const,
  },
  dashboard: {
    metrics: (firmId: string | null) => ['dashboard', firmId, 'metrics'] as const,
    riskScores: (firmId: string | null, entityType?: string) => ['dashboard', firmId, 'risk', entityType] as const,
    notifications: (firmId: string | null) => ['dashboard', firmId, 'notifications'] as const,
  },
  filings: {
    list: (engagementId: string | null) => ['filings', engagementId] as const,
  },
  docRequests: {
    list: (engagementId: string | null) => ['docRequests', engagementId] as const,
  },
  staff: {
    all: (firmId: string | null) => ['staff', firmId] as const,
  },
  portal: {
    dashboard: (clientId: string | null) => ['portal', 'dashboard', clientId] as const,
  },
}
